module.exports = __webpack_public_path__ + "img/roommm.e1dd6bb7.png";